import { render, staticRenderFns } from "./monthCalendar.vue?vue&type=template&id=3bd53fbf&scoped=true"
import script from "./monthCalendar.vue?vue&type=script&lang=js"
export * from "./monthCalendar.vue?vue&type=script&lang=js"
import style0 from "./monthCalendar.vue?vue&type=style&index=0&id=3bd53fbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd53fbf",
  null
  
)

export default component.exports